import { Button, InputLabel, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import AuthContainer from "../../../components/containers/AuthContainer";
import TextInput from "../../../components/textInput";
import { Link, useNavigate } from "react-router-dom";
import { APP_LOGO } from "../../../assets";

const ForgotPage = () => {
  const navigate = useNavigate();
  return (
    <AuthContainer>
      <Typography
        mt={2}
        fontSize={"1.5rem"}
        fontWeight={600}
        textAlign={"center"}
      >
        Forgot Password
      </Typography>
      <Typography fontSize={"body1"} textAlign={"center"}>
        Please enter your email address
      </Typography>

      <Grid container rowSpacing={2} mt={4}>
        <Grid size={12}>
          <InputLabel className={"input-label"}>Email</InputLabel>
          <TextInput />
        </Grid>
      </Grid>

      <Stack
        my={2}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={0.5}
      >
        <Link className="forgot-link" to={"/login"}>
          Back
        </Link>
      </Stack>

      <Button
        variant="contained"
        onClick={() => navigate("/reset-password")}
        sx={{
          mt: 2,
          height: 45,
        }}
      >
        Send Code
      </Button>
    </AuthContainer>
  );
};

export default ForgotPage;
